"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCategoriesEndpoint = exports.createCategoryEndpoint = exports.editCategoryEndpoint = exports.editPageEndpoint = exports.createPageEndpoint = exports.pageContentEndpoint = void 0;
var routes_1 = require("~shared/utils/routes");
exports.pageContentEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/content/page',
    method: 'post'
});
exports.createPageEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/content/page/create',
    method: 'post'
});
exports.editPageEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/content/page/edit',
    method: 'post'
});
exports.editCategoryEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/content/category/edit',
    method: 'post'
});
exports.createCategoryEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/content/category/create',
    method: 'post'
});
exports.getCategoriesEndpoint = routes_1.asStandardEndpoint({
    apiPath: '/content/category/:lang(en|zh)',
    method: 'get'
});
//# sourceMappingURL=page.js.map